import Component from '@glimmer/component'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import type { PhosphorIconName } from 'phosphor-icons'

interface Signature {
  Element: HTMLDivElement
  Args: {
    appearance: LegacyProductRe | LegacyProductRex | LegacyProductMs | LegacyProductWl | LegacyProductFp
    icon: PhosphorIconName
    label?: string
    resetAction?: () => void
  }
}

export class SectionBoxHeader extends Component<Signature> {
  get productColors() {
    switch (this.args.appearance) {
      case 'maths':
        return {
          header: 'bg-ms-green-200',
          icon: 'text-ms-green-300 w-6 h-6',
        }
      case 're':
      case 'rex':
      case 'fast_phonics':
        return {
          header: 'bg-oceany-blue-200',
          icon: 'text-oceany-blue-300 w-6 h-6',
        }
      case 'writing_legends':
        return {
          header: 'bg-wl-blue-150',
          icon: 'text-wl-blue-300 w-6 h-6',
        }
      default:
        return {
          header: '',
          icon: '',
        }
    }
  }

  <template>
    <div
      class="{{this.productColors.header}} flex justify-between rounded-t-lg px-4 py-3"
      data-test-section-box-header
      ...attributes
    >
      <div class="flex items-center gap-3">
        <div class="inline-flex h-12 w-12 items-center justify-center rounded-full bg-white">
          <PhosphorIcon data-test-icon @icon={{@icon}} class={{this.productColors.icon}} />
        </div>
        <h3>
          {{@label}}
        </h3>
      </div>
      {{#if @resetAction}}
        <button
          data-test-reset-button
          class="border-0 font-bold focus:outline-hidden"
          type="button"
          name="button"
          {{on "click" @resetAction}}
        >{{t "reset"}}</button>
      {{/if}}
    </div>
  </template>
}
